import React from 'react';
import AmamentacaoPraticaLP from '../components/AmamentacaoPraticaLP';
import VturbPlayer from '../components/VturbPlayer';

// Oferta R$147 + VSL — mesma página da home, com VSL no hero.
const CHECKOUT_147_VSL = "https://pay.hotmart.com/B99235195O?off=prxcszkk&checkoutMode=10&src=offer147vsl";
const VSL_PLAYER_ID = "6acfdcf61ef6afdff7fdd30c";

const Offer147VslPage = () => {
  return (
    <AmamentacaoPraticaLP
      checkoutUrl={CHECKOUT_147_VSL}
      priceMain="R$ 147,00"
      priceInstallments="ou em até 12x de R$ 15,30"
      vsl={<VturbPlayer playerId={VSL_PLAYER_ID} />}
    />
  );
};

export default Offer147VslPage;
